"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaNotaFiscal = exports.yupNotaFiscal = void 0;
const yup = __importStar(require("yup"));
const utils_1 = require("../utils");
exports.yupNotaFiscal = yup.object({
    parcela: yup.string().max(2).required().label('Parcela'),
    xml: yup.string().max(1024).required().label('XML da nota'),
    pdf: yup.string().max(1024).required().label('PDF da nota'),
    status: yup.string().max(20).required().label('Status'),
    motivo: yup.string().max(255).notRequired().label('Motivo do status'),
    valor: yup.number().default(0).required().label('Valor'),
    envio: (0, utils_1.sge2Date)().label('Data de envio').nullable().default(null),
    hrEnvio: yup.string().max(6).notRequired().label('Hora de envio'),
    emissao: (0, utils_1.sge2Date)().label('Data de emissao').nullable().default(null),
    hrEmissao: yup.string().max(6).notRequired().label('Hora de emissao'),
    producao: yup.boolean().required().default(true).label('Ambiente de producao'),
    idNota: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .label('Identificador nota-fiscal'),
    idAluno: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .label('Aluno'),
    idMensalidade: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .label('Mensalidade'),
});
exports.schemaNotaFiscal = exports.yupNotaFiscal.shape({});
